import { isFuture, isPast, isAfter } from 'date-fns';
import { ClockAlertIcon } from 'lucide-react';
import type { ServiceOrderListEntry } from 'contracts/service-orders';
import { cn } from 'lib/utils';

type Props = {
  serviceOrder: ServiceOrderListEntry
}

export const DeadlineOverdueIndicator = ({ serviceOrder }: Props) => {
  if (!isServiceOverdue(serviceOrder)) {
    return <div className={'w-4'}></div>;
  }

  return (
    <div className={cn(
      'w-5 h-5 rounded-full text-red-500',
      'flex items-center justify-center',
    )}>
      <ClockAlertIcon className={'w-5 h-5'} />
    </div>
  );
};

const isServiceOverdue = ({
                            deadlineDate,
                            endDate,
                          }: ServiceOrderListEntry) => {
  if (!deadlineDate) {
    return false;
  } else if (isFuture(new Date(deadlineDate))) {
    return false;
  } else if (!endDate && isPast(new Date(deadlineDate))) {
    return true;
  } else if (endDate && deadlineDate) {
    return isAfter(new Date(endDate), new Date(deadlineDate));
  }
};